<template>
  <div
    class="form-side qi-editor"
    v-show="isVisible"
    v-loading="isLoading">
    <div class="row">
      <div class="col-md-6 col-12 align-self-end">
        <h1 class="page-title">{{formTitle}}</h1>
      </div>
      <template v-if="hasCreateNew">
        <div class="col-md-auto col-12 mb-3" style="margin-left: auto" >
          <logo-button
            class="btn-mobile-full"
            @click="sendEmail"
          >
            {{L10n('send-email')}}
          </logo-button>
        </div>
        <div class="col-md-auto col-12 mb-3">
          <logo-button
            class="btn-mobile-full"
            :get-pdf-content="getPdfContent"
            @click="downloadPDF"
          >
            {{L10n('download-pdf')}}
          </logo-button>
        </div>
        <div class="col-md-auto col-12 mb-3">
          <button
            type="button"
            class="btn btn-control btn-border grey btn-size-s btn-mobile-full"
            @click.prevent="setCommand('back')"
            v-html="L10n('back')"/>
        </div>
      </template>
      <template v-else>
        <div class="col-md-auto col-12 mb-3" style="margin-left: auto">
          <button
            type="button"
            class="btn btn-control btn-border grey btn-size-s btn-mobile-full"
            @click.prevent="setCommand('cancel')"
            v-html="L10n('cancel')"/>
        </div>
      </template>
    </div>
    <div class="qi-form-content white-background">
      <form-qi
        ref="Form"
        :stockTechnicalRemark="stockData.stockTechnicalRemark"
        :data="data"
        :model="formModel"
        :rfQ2ID="rfQ2ID"
        :rfQ3ID="rfQ3ID"
        :stockID="stockID"
        :isAllowToComplete="isAllowToComplete"
        :isAllowToEdit="isAllowToEdit"
        @on-change-search="onChangeSearch"
        @on-update-po="onUpdatePo"
        @on-add-core="onAddCore"
        @on-update-stock="onUpdateStock"
        @on-complete="handleOnComplete"
        @on-edit="handleOnEdit"
        @onPartNumber="onPartNumber"
        @updateModelItem="handlerUpdateModelItem"
        @on-update-customer="handlerUpdateCustomer"
        @on-open-customer-followup="onOpenCustomerFollowup"
        @on-open-supplier-followup="onOpenSupplierFollowup"
        @change="handleFormData"
      />
    </div>
    <dialog-confirm
      ref="dialogConfirm"
      :config="configControlsDialog"
      @confirm="(data, cb) => {cb()}">
      <template v-slot:footer-confirm="confirmProps">
        <button
          type="button"
          class="btn btn-control btn-border grey btn-size-s"
          @click.prevent="confirmProps.clickHandler('cancel')">
          {{L10n('cancel')}}
        </button>
        <button
          type="button"
          class="btn btn-control btn-border blue btn-size-s"
          ref="btnConfirm"
          @click.prevent="confirmProps.clickHandler('confirm')">
          {{L10n('yes')}}
        </button>
      </template>
    </dialog-confirm>
    <send-email-wrap
      ref="sendEmail"
      :qiID="currentID"
    />
  </div>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { ServiceRepairExchangeOrderFollowUp } from '@/services/RepairExchangeOrderFollowUp'
import { ServicePdf } from '@/services/pdf-generators'
import { downloadBase64 } from '@/utils/files'
import { ServiceStocks } from '@/services/Stocks'
import { ServiceRFQ3s } from '@/services/RFQ3s'
import { ServiceRFQ2s } from '@/services/RFQ2s'

export default {
  name: 'EditorQI',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'logo-button': () => import(/* webpackChunkName: 'UI' */ '@/components/Shared/LogoButton'),
    'send-email-wrap': () => import(/* webpackChunkName: 'QI' */ './SendEmailWrap'),
    'form-qi': () => import(/* webpackChunkName: 'QI' */ './Form'),
    'dialog-confirm': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogConfirm')
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'QualityInspections/Patch/${data.id}',
      isEditQI: false,
      rfQ2ID: null,
      rfQ2Data: {},
      rfQ3ID: null,
      rfQ3Data: {},
      stockID: null,
      stockData: {},
      configControlsDialog: {},
      partNumber: null
    }
  },
  computed: {
    currentEmployeeID () {
      return this.$store.state.currentUser.employeeID
    },
    permissions () {
      return this.$store.getters.get('permissions')
    },
    isAllowToComplete () {
      return !this.data.complete || this.isEditQI
    },
    isAllowToEdit () {
      return this.permission(this.permissions, 'isAllowToEditQIs')
    },
    formTitle () {
      return [this.formData.partSN, this.partNumber].filter((v) => v).join(' - ') || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        partID: '',
        partSN: '',
        entryDate: new Date(),
        qty: 1,
        supplierCompanyID: '',
        conditionID: '',
        remark: '',
        releaseID: '',
        employeeID: this.currentEmployeeID,
        weightDimensions: '',
        tagDate: '',
        mfgDate: '',
        awb: 'NO',
        tagInfoCompanyID: '',
        tracebilityCompanyID: '',
        stockID: null,
        awbDetails: '',
        packagingIn: false,
        packagingOut: false,
        nonIncident: false,
        technicalReport: false,
        partVisualCheck: false,
        releaseApproved: false,
        complete: false
      }
    },
    onPartNumber (data) {
      this.partNumber = data && data.partNumber
    },
    handleChangeID () {
      this.isEditQI = false
      this._resetData()
    },
    handleChangeData () {
      this.isEditQI = false
      this._resetData()
    },
    _resetData () {
      this.rfQ2ID = null
      this.rfQ2Data = {}
      this.rfQ3ID = null
      this.rfQ3Data = {}
      this.stockID = null
      this.stockData = {}
    },
    handleOnComplete () {
      if (this.hasCreateNew) {
        this.completeQI()
      } else {
        this.setCommand('save')
      }
    },
    handleOnEdit () {
      this.isEditQI = true
      this._resetData()
    },
    async completeQI () {
      await this.$refs.Form.validate()

      this.$refs.Form.updateFormData({
        complete: true
      })

      this.setCommand('save_edit')
    },
    // More Info
    onChangeSearch (key, value, data) {
      switch (key) {
        case 'rfQ2ID':
          this.onChangeRfQ2ID(value, data)
          break
        case 'rfQ3ID':
          this.onChangeRfQ3ID(value, data)
          break
        case 'stockID':
          this.onChangeStockID(value, data)
          break
        default:
          console.error(`QI -> ${key} is incorrect key`)
      }
    },
    onChangeRfQ2ID (value, data) {
      this.rfQ2ID = value
      let newData = this.copyObjectProps(this.modelRepairShop(), data)
      this.rfQ2Data = data || {}
      this.$refs.Form.updateFormData(newData)
    },
    onChangeRfQ3ID (value, data) {
      this.rfQ3ID = value
      let newData = this.copyObjectProps(this.modelCoreExchange(), data)
      this.rfQ3Data = data || {}
      this.$refs.Form.updateFormData(newData)
    },
    onChangeStockID (value, data) {
      this.stockID = value
      let newData = this.copyObjectProps(this.modelSearchStock(), data)
      this.stockData = data || {}
      this.$refs.Form.updateFormData(newData)
    },
    modelRepairShop () {
      return {
        partID: null,
        partSN: '',
        supplierCompanyID: null,
        entryDate: new Date(),
        qty: 1
      }
    },
    modelCoreExchange () {
      return {
        partID: null,
        entryDate: new Date(),
        qty: 1
      }
    },
    modelSearchStock () {
      return {
        stockID: null,
        partID: null,
        partSN: '',
        partDescription: '',
        // supplierCompanyID: null,
        entryDate: new Date(),
        qty: 1,
        conditionID: null,
        releaseID: null,
        tagInfoCompanyID: null,
        tagDate: ''
      }
    },
    // controls right
    onOpenCustomerFollowup () {
      if (!this.rfQ3Data) {
        return
      }
      const { po } = this.rfQ3Data
      const routeData = this.$router.resolve({
        name: 'SupportCustomerPoFollowup',
        query: {
          po: po
        }
      })

      window.open(routeData.href, '_blank')
    },
    onOpenSupplierFollowup () {
      if (!this.rfQ3Data) {
        return
      }
      const { po } = this.rfQ3Data
      const routeData = this.$router.resolve({
        name: 'SupportOpenPO',
        query: {
          po: po
        }
      })
      window.open(routeData.href, '_blank')
    },
    async handlerUpdateCustomer () {
      const filters = {
        baxpo: this.rfQ2Data.po,
        partID: this.rfQ2Data.partID,
        partSN: this.rfQ2Data.partSN
      }
      this.isLoading = true
      try {
        await ServiceRepairExchangeOrderFollowUp
          .updateAllByFilters(filters, {})
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e, e.message)
      } finally {
        this.isLoading = false
      }
    },
    onUpdatePo () {
      this.configControlsDialog = {
        title: this.L10n('update-rfq2'),
        text: this.L10n('are-you-sure-update-rfq2')
      }
      this.$refs.dialogConfirm.show({}, () => {
        let data = {
          id: this.rfQ2ID,
          receivedDate: new Date(),
          qtyReceived: this.formData.qty
        }
        ServiceRFQ2s.patch(data)
          .then(() => {
            this.requestSuccessHandler()
          })
      })
    },
    onAddCore () {
      this.configControlsDialog = {
        title: this.L10n('update-core-rfq3'),
        text: this.L10n('are-you-sure-update-core-rfq3')
      }
      this.$refs.dialogConfirm.show({}, () => {
        let data = {
          rfqid: this.rfQ3Data.rfqid,
          partID: this.formData.partID,
          partSN: this.formData.partSN,
          qty: 1,
          conditionID: this.formData.conditionID,
          price: 1,
          chosen: true,
          exchangeCoreReceived: true,
          quoteDate: new Date()
        }
        ServiceRFQ3s.post(data)
          .then(() => {
            this.requestSuccessHandler()
          })
      })
    },
    onUpdateStock () {
      this.configControlsDialog = {
        title: this.L10n('update-stock'),
        text: this.L10n('are-you-sure-update-stock')
      }
      this.$refs.dialogConfirm.show({}, () => {
        let data = {
          id: this.stockID,
          conditionID: this.formData.conditionID,
          releaseID: this.formData.releaseID,
          tagInfoCompanyID: this.formData.tagInfoCompanyID,
          tagDate: this.formData.tagDate,
          supplierPaymentDate: this.formData.mfgDate,

          weightDimensions: this.formData.weightDimensions,
          nonIncident: this.formData.nonIncident,
          traceabilityCompanyID: this.formData.tracebilityCompanyID
        }
        ServiceStocks.patch(data)
          .then(() => {
            this.requestSuccessHandler()
          })
      })
    },
    sendEmail (logoType) {
      this.$refs.sendEmail.show({ logoType })
    },
    // controls top
    async getPdfContent () {
      return ServicePdf.generateQiContent({ id: this.currentID, translate: this.L10n })
    },
    async downloadPDF (logoKey) {
      this.isLoading = true
      const { partSN } = this.formData
      try {
        const { data: pdf } = await ServicePdf.generateQi({ id: this.currentID, translate: this.L10n, logoKey })
        downloadBase64(pdf, `qi-${partSN}.pdf`)
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
